class ConversationLabPdpVariantSelector {
  constructor(section) {
    this.section = section;
    this.selector = section.querySelector('[data-clp-variant-selector]');
    if (!this.selector) return;

    this.options = this.selector.querySelectorAll('.conversation-lab-pdp__variant');
    this.priceDisplay = section.querySelector('.product-detail__price-sale');
    this.comparePriceDisplay = section.querySelector('[data-variant-compare-price]');
    this.addToCartBtn = section.querySelector('.product-detail__register-btn');

    this.bindEvents();
  }

  // product-detail-price.liquid only prints the compare-at element when the
  // variant that loads first has a compare-at price. If that one doesn't and a
  // later one does, there is nothing on the page to fill, so build it once here
  // rather than changing a snippet other product pages also render.
  compareEl() {
    if (this.comparePriceDisplay) return this.comparePriceDisplay;
    const values = this.section.querySelector('[data-price-display]');
    if (!values) return null;
    const el = document.createElement('span');
    el.className = 'product-detail__price-compare';
    el.setAttribute('data-variant-compare-price', '');
    el.hidden = true;
    values.appendChild(el);
    this.comparePriceDisplay = el;
    return el;
  }

  bindEvents() {
    this.options.forEach((option) => {
      option.addEventListener('click', () => this.selectVariant(option));
    });
  }

  selectVariant(option) {
    // Variants already in the cart are locked — they can't be re-selected.
    if (option.classList.contains('is-in-cart')) return;

    this.options.forEach((opt) => opt.classList.remove('is-selected'));
    option.classList.add('is-selected');

    // The section renders each variant's price through Liquid's money filter and
    // parks it on the option, so the total picks up the shop's own formatting —
    // thousands separator included — instead of being rebuilt from the cents.
    const priceFormatted = option.getAttribute('data-clp-variant-price-formatted');
    const price = parseInt(option.getAttribute('data-clp-variant-price'), 10);
    if (this.priceDisplay) {
      if (priceFormatted) {
        this.priceDisplay.textContent = priceFormatted;
      } else if (!isNaN(price)) {
        this.priceDisplay.textContent = formatMoney(price);
      }
    }

    // Same treatment for the struck-through price: it is rendered for whichever
    // variant loaded first, so without this it would keep showing that variant's
    // compare-at price next to a total that has moved on. Blank means the
    // variant has no saving to show, and the element is hidden outright rather
    // than left holding the previous one.
    const compareFormatted = option.getAttribute('data-clp-variant-compare-formatted');
    const compareDisplay = this.compareEl();
    if (compareDisplay) {
      if (compareFormatted) {
        compareDisplay.textContent = compareFormatted;
        compareDisplay.hidden = false;
      } else {
        compareDisplay.textContent = '';
        compareDisplay.hidden = true;
      }
    }

    const variantId = option.getAttribute('data-clp-variant-id');
    if (this.addToCartBtn && variantId) {
      this.addToCartBtn.setAttribute(
        'data-selected-variants',
        JSON.stringify([{ id: variantId, quantity: 1 }])
      );
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.conversation-lab-pdp').forEach((section) => {
    new ConversationLabPdpVariantSelector(section);
  });
});
